import { ChevronLeft, Close, UnfoldLess } from "@mui/icons-material";
import {
	Box,
	Button,
	Drawer,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import type { ReactNode } from "react";

type SidebarPanelProps = {
	open: boolean;
	onClose: () => void;
	title: string;
	children: ReactNode;
	width?: number | string;
	showBackButton?: boolean;
	onBack?: () => void;
	backLabel?: string;
	showCollapseAll?: boolean;
	onCollapseAll?: () => void;
	collapseAllLabel?: string;
	footer?: ReactNode;
	keepMounted?: boolean;
};

export const SidebarPanel = ({
	open,
	onClose,
	title,
	children,
	keepMounted = true,
	width = 400,
	showBackButton,
	onBack,
	backLabel = "Zpět",
	showCollapseAll,
	onCollapseAll,
	collapseAllLabel = "Collapse filled",
}: SidebarPanelProps) => {
	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			keepMounted={keepMounted}
			PaperProps={{
				sx: {
					width: width,
					maxWidth: "100vw",
					p: 0,
				},
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					height: "100%",
				}}
			>
				{/* Header */}
				<Box
					sx={{
						p: 3,
						pb: 2,
						borderBottom: "1px solid #E9EAEB",
					}}
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="flex-start"
					>
						<Typography
							variant="h1"
							sx={{
								fontSize: 24,
								fontWeight: 600,
								lineHeight: 1.3,
								pr: 4,
							}}
						>
							{title}
						</Typography>
						<IconButton
							onClick={onClose}
							sx={{
								color: "#414651",
								p: 0.5,
							}}
						>
							<Close />
						</IconButton>
					</Stack>

					{/* Action row - Back button and Collapse all */}
					{(showBackButton || showCollapseAll) && (
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
							sx={{ mt: 2 }}
						>
							{showBackButton && (
								<Button
									variant="text"
									color="primary"
									startIcon={<ChevronLeft />}
									onClick={onBack}
									sx={{
										p: 0,
										minWidth: "auto",
										"&:hover": {
											backgroundColor: "transparent",
										},
									}}
								>
									{backLabel}
								</Button>
							)}
							{!showBackButton && <Box />}
							{showCollapseAll && (
								<Button
									variant="text"
									color="primary"
									startIcon={<UnfoldLess />}
									onClick={onCollapseAll}
									sx={{
										p: 0,
										minWidth: "auto",
										"&:hover": {
											backgroundColor: "transparent",
										},
									}}
								>
									{collapseAllLabel}
								</Button>
							)}
						</Stack>
					)}
				</Box>

				{/* Scrollable content */}
				<Box
					sx={{
						flex: 1,
						overflowY: "auto",
						p: 2,
					}}
				>
					{children}
				</Box>
			</Box>
		</Drawer>
	);
};
